export default __webpack_public_path__ + "static/media/community-telegram-icon.13e14d29.png";